import React, { useEffect, useState } from "react";

import axios from "axios";
import { Link } from "react-router-dom";
import cup from "../../../../../../../../assets/images/pending3.png";
import EnterImage from "../../../../../../../../assets/images/unsplash_hUHzaiAHuUc.png";
import AuditionCardReuse from "../../../../../../../AuditionAdmin/AuditionCardReuse";
import AllDataHeader from "../../../../../../../Reuseable/AllDataHeader";
import EventsNav from "./EventsNav";
import LoaderPost from "../../../../../../../Reuseable/LoaderPost";

const EventRequestApproval = () => {
  const [events, setEvents] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/audition-admin/audition/request").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.event);
      }
    });
  }, []);

  return (
    <>
      <EventsNav />
      <AllDataHeader
        title="Approved Audition Event"
        image={cup}
        count={"Zero"}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AuditionCardReuse
          data={events}
          urlLink={`/audition-admin/audition/round-video-distribute`}
          url2={`/audition-admin/audition/star-promo-send-feedback`}
        />
      )}
    </>
  );
};

export default EventRequestApproval;
